export default function clampNumberUtil (number, lower, upper) {
  if (number < lower) {
    return lower
  } else if (number > upper) {
    return upper
  } else {
    return number
  }
}
